import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "18.8",
      height: "18.8",
      x: ".6",
      y: ".6",
      fill: "#FDF7F7",
      rx: "9.4"
    }, null, -1),
    _createElementVNode("rect", {
      width: "18.8",
      height: "18.8",
      x: ".6",
      y: ".6",
      stroke: "#DC5656",
      "stroke-width": "1.2",
      rx: "9.4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#DC5656",
      d: "M6.52 6.264a.72.72 0 0 1 .997-.038l.056.054 5.92 6.36.052.06a.8.8 0 0 1-.067 1.037.72.72 0 0 1-.996.037l-.056-.053-5.92-6.36-.051-.061a.8.8 0 0 1 .066-1.036"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#DC5656",
      d: "M13.48 6.264a.72.72 0 0 0-.997-.038l-.056.054-5.92 6.36-.052.06a.8.8 0 0 0 .067 1.037c.276.28.707.29.996.037l.056-.053 5.92-6.36.051-.061a.8.8 0 0 0-.066-1.036"
    }, null, -1)
  ])))
}
export default { render: render }